import script from "./PandyTransferItemRecRetDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PandyTransferItemRecRetDialog.vue?vue&type=script&setup=true&lang=js"

import "./PandyTransferItemRecRetDialog.vue?vue&type=style&index=0&id=43a11f4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a11f4a"]])

export default __exports__